<template>
  <div class="wrap">
    <el-input
      class="area"
      v-model="inputValue"
      :autofocus="autofocus"
      :class="errorSignal ? 'error-border' : ''"
      :minlength="min"
      :maxlength="max"
      v-bind="$attrs"
      v-on="$listeners"
      @focus="inputFocus"
      @blur="inputBlur"
    >
    </el-input>
    <label v-if="isLabel" class="title" :class="change">
      <span v-if="isImportant" class="important">*</span>
      <span>{{ placeholder }}</span>
    </label>
    <label v-else-if="!isLabel && inputValue.length === 0" class="title2">
      <span v-if="isImportant" class="important">*</span>
      <span>{{ placeholder }}</span>
    </label>
    <p v-if="errorSignal" class="error-text">{{ errMessage }}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      change: "",
      errorSignal: false,
      isLabel: true,
    };
  },

  props: {
    value: {},

    placeholder: {
      type: String,
      default: "请输入",
    },

    autofocus: {
      type: Boolean,
      default: false,
    },

    // isLabel: {
    //   type: Boolean,
    //   default: true
    // },

    isImportant: {
      type: Boolean,
      default: true,
    },

    min: {
      type: String,
      default: "0",
    },

    max: {
      type: String,
      default: "1000",
    },

    errMessage: {
      type: String,
      default: "",
    },
  },

  computed: {
    inputValue: {
      get() {
        return this.value;
      },

      set(value) {
        this.$emit("input", value);
      },
    },
  },

  watch: {
    errMessage(val) {
      if (val) {
        this.errorSignal = true;
      } else {
        this.errorSignal = false;
      }
    },

    inputValue: {
      handler(val) {
        // 这种情况说明是外部赋值致使input的值发生改变 (表单回填)
        if (val && !this.change) {
          this.change = "blur";
        }
      },
      immediate: true,
    },
  },

  methods: {
    inputFocus() {
      this.change = "focus";
      this.errorSignal = false;
    },

    inputBlur() {
      if (this.inputValue !== "") {
        this.change = "blur";
      } else {
        this.change = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  position: relative;

  .area {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: #333333;
  }

  .title {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    position: absolute;
    left: 16px;
    top: 20px;
    margin-top: -7px;
    padding: 2px 3px;
    font-size: 14px;
    transform-origin: 0 0;
    background: #fff;
    color: #c1c4cc;
    transition: all 0.3s;
    pointer-events: none;
  }

  .title2 {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    position: absolute;
    left: 16px;
    top: 20px;
    margin-top: -7px;
    padding: 2px 3px;
    font-size: 14px;
    transform-origin: 0 0;
    color: #c1c4cc;
    transition: all 0.3s;
    pointer-events: none;
  }

  .important {
    position: relative;
    top: 2px;
    margin-right: 2px;
    font-size: 16px;
    font-weight: bold;
    color: #e51c23;
  }

  .focus {
    font-size: 12px;
    color: #08a681;
    padding: 2px 3px;
    font-weight: bolder;
    letter-spacing: 0;
    line-height: 16px;
    transform: translate(-2px, -22px);
  }

  .blur {
    font-size: 12px;
    color: #666666;
    padding: 2px 3px;
    letter-spacing: 0;
    line-height: 16px;
    transform: translate(-2px, -22px);
  }

  .error-border {
    /deep/ input {
      border: 1px solid #e51c23;
    }
  }

  .error-text {
    padding: 10px 0 0 4px;
    font-size: 12px;
    color: #e51c23;
  }
}
</style>
